import React from 'react';
import { clamp } from '../../../utils/clamp';

import {
  HeadingLevelProvider,
  useHeadingLevel,
} from '@zapier/heading-level-context';

type Props = {
  children: React.ReactNode;
};

export const HeadingLevel = ({ children }: Props) => {
  const { level } = useHeadingLevel();
  const nextLevel = clamp(level + 1, 1, 6);
  return (
    <HeadingLevelProvider level={nextLevel}>{children}</HeadingLevelProvider>
  );
};
